module.exports = __webpack_public_path__ + "img/camera_bg.8f2eddf6.png";